









import { Component, Prop, Vue } from 'vue-property-decorator';
import { BreadCrumbElement } from '@/models/bread-crumb-element';

@Component({
  name: 'GCustomBreadCrumb',
})
export default class GCustomBreadCrumb extends Vue {
  @Prop() data: BreadCrumbElement[];
  mounted() {}
}
